module.exports = __webpack_public_path__ + "img/AS.caaf405e.svg";